export default __webpack_public_path__ + "static/media/duitnow3.3f09ca24.png";